export default "__VITE_ASSET__ac1a2156__"